import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from "util/CustomScrollbars";

function BrokerNav(props) { 
    return (
        <ul className="nav-menu">

        <li className="nav-header">Broker</li>

        <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/app/dashboard/main">
            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>

            <span className="nav-text text-transform-none"><IntlMessages
                id="sidebar.dashboard"/></span>
            </NavLink>
        </li>

        <li className="menu no-arrow"> 
            <NavLink to="/app/table/basic"> 
                <i className="zmdi zmdi-view-web zmdi-hc-fw"/>
                <span className="nav-text">Agents</span>                                          
            </NavLink>
        </li> 

         <li className="menu no-arrow"> 
            <NavLink to="/app/properties"> 
                <i className="zmdi zmdi-home zmdi-hc-fw"/>
                <span className="nav-text">Properties</span>                                          
            </NavLink>
        </li> 
        </ul>
    )
}

function AgentNav(props) { 
    return (
        <ul className="nav-menu">
        <li className="nav-header"> Agent </li>   
        <li className="menu no-arrow"> 
           <NavLink to="/app/properties/agent"> 
               <i className="zmdi zmdi-collection-text zmdi-hc-fw"/>
               <span className="nav-text">My Listings</span>                                          
           </NavLink>
       </li> 
       <li className="menu no-arrow">
           <NavLink to="/app/custom-views/card-list">
               <i className="zmdi zmdi-view-list zmdi-hc-fw"/>
               {/* <span className="nav-text"><IntlMessages id="sidebar.customViews.cardListView"/></span> */}
               <span className="nav-text"><IntlMessages id="Transactions"/></span>

           </NavLink>
       </li>

        <li className="menu no-arrow">
           <NavLink to="/app/chat">
               <i className="zmdi zmdi-comment zmdi-hc-fw"/>
               <span className="nav-text"><IntlMessages id="sidebar.appModule.chat"/></span>
           </NavLink>
       </li> 


       <li className="menu no-arrow">
           <NavLink to="/app/to-do">
               <i className="zmdi zmdi-check-square zmdi-hc-fw"/>
               <span className="nav-text"><IntlMessages id="sidebar.appModule.toDo"/></span>
           </NavLink>
       </li>

       <li className="menu no-arrow">
           <NavLink to="/app/contact">
               <i className="zmdi zmdi-account-box zmdi-hc-fw"/>
               <span className="nav-text"><IntlMessages id="sidebar.appModule.contact"/></span>
           </NavLink>
       </li>
       </ul>
    )
}

function ClientNav(props) { 
    return(
    <ul className="nav-menu" >
        <li className="nav-header"> Client (Buyer/Seller) </li>
        <li className="menu no-arrow"> 
            <NavLink className="prepend-icon" to="/app/transaction">
                <i className="zmdi zmdi-check-all  zmdi-hc-fw "/>
                <span className="nav-text"> Progress </span>
            </NavLink>
        </li>
    </ul> 
    )
}


class SidenavContent extends Component {

    componentDidMount() {
        const {history} = this.props;
        const that = this;
        const pathname = `#${history.location.pathname}`;// get current path

        const subMenuLi = document.querySelectorAll('.sub-menu > li');
        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function (event) {
                event.stopPropagation();
            }
        }

        const menuLi = document.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function (event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open')
                    }
                }
                this.classList.toggle('open');
                event.stopPropagation();
            }
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {

        }
    }

    closest(el, selector) {
        try {
            let matchesFn;
            // find vendor prefix
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            // traverse parents
            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (e) {

        }

        return null;
    }
    
    
    // if (isLoggedIn) {
    //     button = <LogoutButton onClick={this.handleLogoutClick} />;
    //   } else {
    //     button = <LoginButton onClick={this.handleLoginClick} />
    //   }
    

    render() {
        let navContent; 
        if (this.props.user === 'broker') { 
            navContent = <BrokerNav />
        } else if (this.props.user === 'agent') { 
            navContent = <AgentNav />
        } else { 
            navContent = <ClientNav />
        }
        return (
            <CustomScrollbars className="scrollbar" style={{height: 'calc(100vh - 70px)'}}>
                {/* <ul className="nav-menu"> */}

                {navContent}
                {/* <ClientNav/> */}





                    {/* <li className="menu">
                        <a role="button" href="javascript:void(0)">
                            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
                            <span className="nav-text">
                            <IntlMessages id="sidebar.dashboard"/>
                        </span>
                        </a>
                        <ul className="sub-menu">
                            <li>
                                <NavLink className="prepend-icon" to="/app/dashboard/default">
                                    <span className="nav-text"><IntlMessages id="sidebar.dashboard.default"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/dashboard/eCommerce">
                                <span className="nav-text text-transform-none"><IntlMessages
                                    id="sidebar.dashboard.ecommerce"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/dashboard/news">
                                    <span className="nav-text"><IntlMessages id="sidebar.dashboard.news"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/dashboard/intranet">
                                        <span className="nav-text"><IntlMessages
                                            id="sidebar.dashboard.intranet"/></span>
                                </NavLink>
                            </li>
                        </ul>

                    </li> */}





               
              
                    {/* <li className="nav-header"><IntlMessages id="sidebar.view"/></li> */}

                 

                    {/* <li className="timeline_tooltip menu">
                        <a role="button" href="javascript:void(0)">
                            <i className="zmdi zmdi-swap-alt zmdi-hc-fw zmdi-hc-rotate-90"/>
                            <span className="nav-text"><IntlMessages id="sidebar.timeLine"/></span>
                        </a>
                        <ul className="sub-menu">

                            <li>
                                <NavLink className="prepend-icon" to="/app/time-line/default">
                                    <span className="nav-text"><IntlMessages id="sidebar.timeLine.default"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/time-line/default-with-icon">
                                <span className="nav-text"><IntlMessages
                                    id="sidebar.timeLine.defaultwithIcons"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/time-line/left-align">
                                        <span className="nav-text"><IntlMessages
                                            id="sidebar.timeLine.leftAligned"/></span>
                                </NavLink>
                            </li>
                        </ul>
                    </li> */}


                   


                    {/* <li className="menu">
                        <a role="button" href="javascript:void(0)">
                            <i className="zmdi zmdi-calendar zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="sidebar.calendar"/></span>
                        </a>

                        <ul className="sub-menu">
                            <li>
                                <NavLink className="prepend-icon" to="/app/calendar/basic">
                                    <span className="nav-text"><IntlMessages id="sidebar.calendar.basic"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/calendar/cultures">
                                    <span className="nav-text"><IntlMessages id="sidebar.calendar.cultures"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/calendar/dnd">
                                    <span className="nav-text"><IntlMessages id="sidebar.calendar.dnd"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/calendar/popup">
                                    <span className="nav-text"><IntlMessages id="sidebar.calendar.popup"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/calendar/rendering">
                                        <span className="nav-text"><IntlMessages
                                            id="sidebar.calendar.rendering"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/calendar/selectable">
                                        <span className="nav-text"><IntlMessages
                                            id="sidebar.calendar.selectable"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/calendar/timeslots">
                                        <span className="nav-text"><IntlMessages
                                            id="sidebar.calendar.timeslots"/></span>
                                </NavLink>
                            </li>
                        </ul>

                    </li> */}

                    {/* <li className="menu">
                        <a role="button" href="javascript:void(0)">
                            <i className="zmdi zmdi-shopping-cart zmdi-hc-fw"/>
                            <span className="nav-text text-transform-none"><IntlMessages
                                id="sidebar.eCommerce"/></span>
                        </a>

                        <ul className="sub-menu">

                            <li>
                                <NavLink className="prepend-icon" to="/app/ecommerce/products-list">
                                    <span className="nav-text"><IntlMessages
                                        id="sidebar.eCommerce.productsList"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/ecommerce/products-grid">
                                    <span className="nav-text"><IntlMessages
                                        id="sidebar.eCommerce.productsGrid"/></span>
                                </NavLink>
                            </li>
                        </ul>
                    </li> */}

                    {/* <li className="menu">
                        <a role="button" href="javascript:void(0)">
                            <i className="zmdi zmdi-collection-item-8 zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="sidebar.appModule"/></span>
                        </a>

                        <ul className="sub-menu">
                            <li>
                                <NavLink className="prepend-icon" to="/app/app-module/login">
                                    <span className="nav-text"><IntlMessages id="sidebar.appModule.login"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/app-module/sign-up">
                                    <span className="nav-text"><IntlMessages id="sidebar.appModule.signup"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/app-module/forgot-password">
                                    <span className="nav-text"><IntlMessages
                                        id="sidebar.appModule.forgotPassword"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/app-module/lock-screen">
                                    <span className="nav-text"><IntlMessages id="sidebar.appModule.lock"/></span>
                                </NavLink>
                            </li>
                        </ul>
                    </li> */}




                    {/* <li className="menu no-arrow">
                        <NavLink to="/app/to-do-redux">
                            <i className="zmdi zmdi-check-square zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="sidebar.appModule.toDoRedux"/></span>
                        </NavLink>
                    </li>

                    <li className="menu no-arrow">
                        <NavLink to="/app/mail">
                            <i className="zmdi zmdi-email zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="sidebar.appModule.mail"/></span>
                        </NavLink>
                    </li>

                    <li className="menu no-arrow">
                        <NavLink to="/app/mail-redux">
                            <i className="zmdi zmdi-email zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="sidebar.appModule.mailRedux"/></span>
                        </NavLink>
                    </li> */}


                   

                    {/* <li className="menu no-arrow">
                        <NavLink to="/app/contact-redux">
                            <i className="zmdi zmdi-account-box zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="sidebar.appModule.contactRedux"/></span>
                        </NavLink>
                    </li> */}

                    {/* <li className="nav-header"><IntlMessages id="sidebar.extras"/></li>

                    <li className="menu">
                        <a role="button" href="javascript:void(0)">
                            <i className="zmdi zmdi-view-web zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="sidebar.icons"/></span>
                        </a>
                        <ul className="sub-menu">
                            <li>
                                <NavLink className="prepend-icon" to="/app/icons/material">
                                    <span className="nav-text"><IntlMessages id="sidebar.icons.material"/></span>
                                </NavLink>
                            </li>
                        </ul>
                    </li>

                    <li className="menu">
                        <a role="button" href="javascript:void(0)">
                            <i className="zmdi zmdi-collection-bookmark zmdi-hc-fw zmdi-hc-rotate-90"/>
                            <span className="nav-text"><IntlMessages id="sidebar.extraElements"/></span>
                        </a>
                        <ul className="sub-menu">
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-elements/pricing-table">
                                <span className="nav-text"><IntlMessages
                                    id="sidebar.extraElements.pricingTable"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-elements/callouts">
                                    <span className="nav-text"><IntlMessages
                                        id="sidebar.extraElements.callouts"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-elements/testimonials">
                                <span className="nav-text"><IntlMessages
                                    id="sidebar.extraElements.testimonials"/></span>
                                </NavLink>
                            </li>
                        </ul>
                    </li>

                    <li className="menu">
                        <a role="button" href="javascript:void(0)">
                            <i className="zmdi zmdi-pages zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="sidebar.extraPages"/></span>
                        </a>
                        <ul className="sub-menu">
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-pages/about-us">
                                        <span className="nav-text"><IntlMessages
                                            id="sidebar.extraPages.aboutUs"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-pages/contact-us">
                                        <span className="nav-text"><IntlMessages
                                            id="sidebar.extraPages.contactUs"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-pages/blog">
                                    <span className="nav-text"><IntlMessages id="sidebar.extraPages.blog"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-pages/faq">
                                    <span className="nav-text"><IntlMessages id="sidebar.extraPages.faq"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-pages/portfolio">
                                        <span className="nav-text"><IntlMessages
                                            id="sidebar.extraPages.portfolio"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-pages/error-404">
                                    <span className="nav-text"><IntlMessages id="sidebar.extraPages.404"/></span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="prepend-icon" to="/app/extra-pages/error-500">
                                    <span className="nav-text"><IntlMessages id="sidebar.extraPages.500"/></span>
                                </NavLink>
                            </li>
                        </ul>
                    </li> */}

                    {/* <li className="menu">
                        <a role="button" href="javascript:void(0)">
                            <i className="zmdi zmdi-device-hub zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="sidebar.menuLevels"/></span>
                        </a>

                        <ul className="sub-menu">
                            <li>
                                <a role="button" className="prepend-icon" href="javascript:void(0)">
                                    <span className="nav-text"><IntlMessages id="sidebar.menuLevels.level1"/></span>
                                </a>
                            </li>
                            <li className="menu">
                                <a role="button" className="prepend-icon" href="javascript:void(0)">
                                    <span className="nav-text"><IntlMessages id="sidebar.menuLevels.level1"/></span>
                                </a>

                                <ul className="sub-menu">
                                    <li>
                                        <a role="button" href="javascript:void(0)">
                                            <span className="nav-text"><IntlMessages
                                                id="sidebar.menuLevels.level2"/></span>
                                        </a>
                                    </li>
                                    <li className="menu">
                                        <a role="button" href="javascript:void(0)">
                                        <span className="nav-text"><IntlMessages
                                            id="sidebar.menuLevels.level2"/></span>
                                        </a>

                                        <ul className="sub-menu">
                                            <li>
                                                <a role="button" href="javascript:void(0)">
                                                <span className="nav-text"><IntlMessages
                                                    id="sidebar.menuLevels.level3"/></span>
                                                </a>
                                            </li>
                                            <li>
                                                <a role="button" href="javascript:void(0)">
                                                <span className="nav-text"><IntlMessages
                                                    id="sidebar.menuLevels.level3"/></span>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li> */}

                {/* </ul> */}
            </CustomScrollbars>
        );
    }
}

export default withRouter(SidenavContent);



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js